import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Member } from 'functions/src/types/firestore/Game/Tournament/Guestlist';
import { SxProps } from '@mui/material';

export type ParticipantAdminDetailsProps = Omit<
  Member,
  'checkedIn' | 'userId' | 'username' | 'imgUrl' | 'status' | 'tournamentId'
> & { sx?: SxProps };

export function ParticipantAdminDetails(props: ParticipantAdminDetailsProps) {
  const { sx, ...rest } = props;

  return (
    <Stack spacing={3} pt={2} sx={{ ...sx }}>
      {Object.entries(rest).map(([key, value]) => {
        return (
          <Typography
            key={key}
            color="text.secondary"
            textTransform={'none'}
            flexWrap={'nowrap'}
          >
            {`${key}: ${value || `no ${key}`}`}
          </Typography>
        );
      })}
    </Stack>
  );
}
